import { render, staticRenderFns } from "./TransferVoucherToOtherCustomerModal.vue?vue&type=template&id=99849d4a&scoped=true&"
import script from "./TransferVoucherToOtherCustomerModal.vue?vue&type=script&lang=js&"
export * from "./TransferVoucherToOtherCustomerModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferVoucherToOtherCustomerModal.vue?vue&type=style&index=0&id=99849d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99849d4a",
  null
  
)

export default component.exports